module.exports = __webpack_public_path__ + "static/media/leaseActive.15dae087.png";